import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyD13QibGlvSYQGmzNZqTrUAWTds1XaMIxE",
    authDomain: "upee-30b66.firebaseapp.com",
    projectId: "upee-30b66",
    storageBucket: "upee-30b66.appspot.com",
    messagingSenderId: "438101256342",
    appId: "1:438101256342:web:c0df2d0e3577581080fab7",
    measurementId: "G-B2VXRV3387"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// const analytics = getAnalytics(app);